import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorIsSWRegistered = (state) => state[KEY_REDUCER_SW].isSWRegistered;